import PrivacityTerm from 'modules/terms/PrivacyTerm'
import React from 'react'

export default function PrivacyPolicie() {
  return (
    <PrivacityTerm />
  )
}